import store from '../store';
import router from '../router';

// Short-circuit guard: if AI Matching is not enabled for this event, send the participant
// back to the lobby. Used on the matching profile + AI matches routes so events without
// the feature never expose these screens.
export default function requireAiMatchingEnabled({ next }) {
  const features = store.getters['CurrentEvent/features'];

  if (!features || !features.aiMatchingEnabled) {
    return router.replace({ name: 'lobby' }).catch(() => {});
  }

  return next();
}
